import moment from "moment-timezone"

export const isDateAfter = (endTime: string, timezone: string): boolean => {
  return moment
    .tz(endTime, timezone)
    .isAfter(moment.tz(moment(), timezone), "second")
}
